import { useNavigate } from 'react-router-dom';
import { MdArrowRight, MdBusiness, MdCandlestickChart, MdLogout } from 'react-icons/md';

import routes from '@/constants/routes';
import { useAuthenticationStore } from '@/store';
import type { AuthenticationState } from '@/types';

import { TextLink } from '../text/Texts';
import styles from './user-drop-down.module.css';
import { FaGlobe } from 'react-icons/fa';
import { showTypedModal } from '@/common/common_utils';
import { SelectLanguageDialogModal } from './SelectLanguageDialog';
import { HiOutlineGlobeAlt } from 'react-icons/hi';

const UserDropdown = () => {
	const navigate = useNavigate();

	const { user } = useAuthenticationStore(
		(state: AuthenticationState) => state,
	);

	return (
		<div className={styles.userDropdown}>
			<div className={styles.userDropdownHeader}>
				<div className={styles.userDropdownAvatar}>A</div>
				<div className="flex flex-col">
					<p className={styles.userDropdownUserName}>
						{user.firstName} {user.lastName}
					</p>
					<p className={styles.userDropdownUserEmail}>{user.email}</p>
				</div>
			</div>
			<div className={styles.userDropdownDivider} />
			<div className={styles.userDropdownBusiness}>
				<div className={styles.userDropdownBusinessInfo}>
					<p className={styles.userDropdownBusinessName}>
						Para Xpress...
					</p>
					<p className={styles.userDropdownBusinessSubtext}>
						Create or switch business
					</p>
				</div>
				<MdArrowRight size={24} className="text-onSurfaceVariant" />
			</div>
			<div className={styles.userDropdownDivider} />
			<button
				type="button"
				className={`${styles.userDropdownMenuItem} cursor-pointer flex items-center gap-2`}
				onClick={() => navigate(routes['/account'])}
			>
				<MdBusiness size={24} className="text-primary" />
				<p
					className={`${styles.userDropdownMenuItemText} text-primary`}
				>
					Account
				</p>
			</button>
			<button
				type="button"
				className={`${styles.userDropdownMenuItem} cursor-pointer flex items-center gap-2`}
				onClick={() => navigate(routes['/settings'])}
			>
				<MdCandlestickChart size={24} className="text-primary" />
				<p
					className={`${styles.userDropdownMenuItemText} text-primary`}
				>
					Settings
				</p>
			</button>
			<button
				type="button"
				className={`${styles.userDropdownMenuItem} cursor-pointer flex items-center gap-2`}
				onClick={async () => {
					await showTypedModal(SelectLanguageDialogModal, {});
				}}
			>
				<HiOutlineGlobeAlt size={24} className="text-primary" />
				<p className={`${styles.userDropdownMenuItemText} text-primary`}>
					Language (en-US)
				</p>
			</button>
			<button
				className={`${styles.userDropdownMenuItem} flex items-center gap-2`}
				onClick={() => navigate(routes['/logout'])}
				type="button"
			>
				<MdLogout size={24} className="text-error" />
				<p className={styles.userDropdownLogoutText}>Logout</p>
			</button>
			<div className={styles.userDropdownDivider} />
			<div className={styles.userDropdownFooter}>
				<TextLink
					className={styles.userDropdownFooterText}
					text="Terms & Conditions"
					link="https://www.xpress.ph/terms"
				/>
				<span className="text-primaryContainer">•</span>
				<TextLink
					className={styles.userDropdownFooterText}
					text="Privacy Policy"
					link="https://www.xpress.ph/privacy-policy"
				/>
			</div>
		</div>
	);
};

export default UserDropdown;
